import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Button } from '../components/ui/button';

const LOGO_URL = 'https://www.sdtlab.it/assets/images/SDT_logo_2025_nobg.png';

const PrivacyPage = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-white">
      {/* Simple Header */}
      <header className="fixed w-full z-50 bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <Link to="/" className="flex items-center space-x-3">
              <img src={LOGO_URL} alt="SDTLab Logo" className="h-14 w-auto" />
            </Link>
            <Link to="/">
              <Button variant="ghost" className="text-gray-600 hover:text-amber-700">
                <ArrowLeft className="w-4 h-4 mr-2" />
                {t.nav.home}
              </Button>
            </Link>
          </div>
        </div>
      </header>

      <main className="pt-32 pb-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              {t.privacy.title}
            </h1>
            <p className="text-gray-500">
              {t.privacy.lastUpdate}: 1 Luglio 2025
            </p>
          </div>

          {/* Content */}
          <div className="bg-white rounded-3xl shadow-sm border border-gray-200 p-8 md:p-12">
            <div className="space-y-10">
              {t.privacy.sections.map((section, index) => (
                <div key={index}>
                  <h2 className="text-xl font-bold text-gray-800 mb-4">
                    {section.title}
                  </h2>
                  <p className="text-gray-600 leading-relaxed">
                    {section.content}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>

      {/* Simple Footer */}
      <footer className="bg-gray-900 text-white py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Smart Digital Technology LAB. {t.footer.rights}.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPage;